var map = {
	"./SearchIcon.svg": 5233,
	"./Vector.svg": 4726,
	"./analytics.svg": 9150,
	"./approval.svg": 7250,
	"./arrowIcon.svg": 4763,
	"./backArrow.svg": 3352,
	"./billing.svg": 1428,
	"./calendar.svg": 782,
	"./campaigns.svg": 7232,
	"./checkbox.svg": 6752,
	"./chevron_down.svg": 9794,
	"./chevron_left.svg": 8910,
	"./chevron_right.svg": 5138,
	"./collapseIcon.svg": 5539,
	"./completedBadgeStatus.svg": 578,
	"./copyIcon.svg": 7887,
	"./crossIcon.svg": 8979,
	"./currencyIcon.svg": 8663,
	"./deleteIcon.svg": 6696,
	"./deleteIconAnalytics.svg": 9519,
	"./deleteIconDisabled.svg": 131,
	"./delink.svg": 7567,
	"./discountIcon.svg": 1028,
	"./documentIcon.svg": 8690,
	"./download.svg": 8728,
	"./downloadIcon.svg": 3929,
	"./downloadIconAnalytics.svg": 3483,
	"./editIcon.svg": 8071,
	"./emptyCase.svg": 3949,
	"./errorIcon.svg": 5468,
	"./eyeIcon.svg": 5865,
	"./eyeSlashIcon.svg": 5893,
	"./fieldsIcon.svg": 1990,
	"./filterIcon.svg": 4725,
	"./greenTick.svg": 8021,
	"./help.svg": 9800,
	"./home.svg": 2781,
	"./info.svg": 3759,
	"./jioMarketLogo.svg": 7564,
	"./jioMartLogo.svg": 4742,
	"./leftArrow.svg": 9808,
	"./link.svg": 1219,
	"./listings.svg": 7706,
	"./liveBadgeStatus.svg": 9871,
	"./myProfile.svg": 4599,
	"./notify.svg": 827,
	"./onboarding.svg": 1558,
	"./orders.svg": 6798,
	"./pauseBadgeStatus.svg": 7659,
	"./pauseIcon.svg": 5027,
	"./pauseIconDisable.svg": 3456,
	"./pendingBadgeStatus.svg": 7102,
	"./playIcon.svg": 8517,
	"./plusIcon.svg": 7018,
	"./profile.svg": 2317,
	"./refreshIcon.svg": 1685,
	"./requestApproval.svg": 7326,
	"./rightArrow.svg": 6582,
	"./sampleCsv.svg": 8250,
	"./savedBadgeStatus.svg": 3993,
	"./scheduledBadgeStatus.svg": 7555,
	"./settings.svg": 4369,
	"./sort.svg": 5197,
	"./sortIcon.svg": 3909,
	"./sponsored.svg": 9631,
	"./successIcon.svg": 769,
	"./support.svg": 8881,
	"./trashIcon.svg": 7679,
	"./type.svg": 8481,
	"./uploadIcon.svg": 2785,
	"./userManagement.svg": 2773,
	"./warning.svg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;